import { motion } from "framer-motion";

const chapters = [
  {
    n: "01",
    title: "THE SOUND",
    body: "Industrial pressure. 140 BPM and up. Every set is built live — no sync button, no safety net. If it doesn't rattle the room, it doesn't leave the crate.",
  },
  {
    n: "02",
    title: "THE MACHINE",
    body: "CDJs, 909s, battered mixers and a wall of cables. The gear is the instrument. We film it, we break it, we push it past what the manual allows.",
  },
  {
    n: "03",
    title: "THE COLLECTIVE",
    body: "One DJ at the front, a whole colony behind. Ants Don't Sleep is a crew — selectors, visual artists, and warehouse ghosts who keep the floor moving till sunrise.",
  },
];

export default function Manifesto() {
  return (
    <section id="manifesto" data-testid="manifesto-section" className="border-b border-white/15">
      <div className="px-4 sm:px-8 py-20 sm:py-28">
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
          className="font-mono-x text-[11px] tracking-[0.3em] text-white/40 uppercase mb-14"
          data-testid="manifesto-overline"
        >
          [00] — THE MANIFESTO
        </motion.p>
        <div className="grid grid-cols-1 lg:grid-cols-3 border-t border-l border-white/15">
          {chapters.map((c, i) => (
            <motion.article
              key={c.n}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.8, delay: i * 0.12, ease: [0.16, 1, 0.3, 1] }}
              className="group border-r border-b border-white/15 p-8 sm:p-10 hover:bg-white transition-colors duration-300"
              data-testid={`manifesto-chapter-${c.n}`}
            >
              <span className="font-mono-x text-xs tracking-[0.3em] text-[#ff3b1d]">
                [{c.n}]
              </span>
              <h3 className="font-mono-x font-bold uppercase tracking-tighter text-2xl sm:text-3xl mt-6 mb-5 group-hover:text-black transition-colors duration-300">
                {c.title}
              </h3>
              <p className="text-sm leading-relaxed text-white/60 group-hover:text-black/70 transition-colors duration-300">
                {c.body}
              </p>
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
}
